import { render } from "./CalendarHiddenFields.vue?vue&type=template&id=2d1ad2cf"
import script from "./CalendarHiddenFields.vue?vue&type=script&lang=js"
export * from "./CalendarHiddenFields.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__